import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import API from '../services/api'; // Ensure this path matches your folder structure
import { THEME } from '../constants/theme';

const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    // Page load hotay hi purana kachra saaf karein taake fresh session shuru ho
    useEffect(() => {
        localStorage.clear();
    }, []);

    const handleLogin = async (e) => {
        if (e) e.preventDefault();
        setLoading(true);
        setError('');
    
        try {
            // API call to backend
            const res = await API.post('/auth/login', { username, password });
    
            if (res.data.success) {
                const userData = res.data.user;
                
                // 1. Token aur User details save karein
                localStorage.setItem('token', res.data.token);
                localStorage.setItem('user', JSON.stringify(userData));

                // 2. Role check kar ke sahi dashboard par bhejein
                if (userData.roles && userData.roles.includes('Admin')) {
                    navigate('/dashboard'); 
                } else {
                    navigate('/employee-dashboard');
                }
            }
        } catch (err) {
            // Server se aane wala error message dikhayein
            setError(err.response?.data?.message || "Invalid credentials or server error");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={styles.page}>
            {/* Awesome Background Decoration */}
            <div style={styles.circle1}></div>
            <div style={styles.circle2}></div>

            <div style={styles.card}>
                <div style={styles.logoBadge}>UM</div>
                
                <h2 style={styles.title}>{THEME.footerCompany.toUpperCase()}</h2>
                <p style={styles.subtitle}>Welcome back! Please enter your details.</p>

                {/* Error Box */}
                {error && <div style={styles.errorBox}>⚠️ {error}</div>}

                <form onSubmit={handleLogin} style={styles.form}>
                    <div style={styles.inputGroup}>
                        <label style={styles.label}>Username</label>
                        <input 
                            type="text" 
                            placeholder="Enter your username"
                            style={styles.input} 
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                        />
                    </div>
                    
                    <div style={styles.inputGroup}>
                        <label style={styles.label}>Password</label>
                        <input 
                            type="password" 
                            placeholder="••••••••"
                            style={styles.input} 
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </div>

                    <button 
                        type="submit" 
                        disabled={loading} 
                        style={loading ? styles.btnDisabled : styles.btn}
                    >
                        {loading ? 'Verifying...' : 'Sign In'}
                    </button>
                </form>

                <div style={styles.footer}>
                    © {THEME.year} {THEME.footerCompany} ERP System
                </div>
            </div>
        </div>
    );
};

// --- 🎨 STYLES (Your Original Awesome Design) ---
const styles = {
    page: { 
        height: '100vh', 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        backgroundColor: '#0f172a', 
        background: `linear-gradient(135deg, #0f172a 0%, ${THEME.sidebarBg} 100%)`,
        overflow: 'hidden',
        position: 'relative',
        fontFamily: "'Inter', sans-serif"
    },
    circle1: { 
        position: 'absolute', top: '-10%', left: '-5%', width: '400px', height: '400px', 
        borderRadius: '50%', background: `radial-gradient(circle, ${THEME.secondary}22 0%, transparent 70%)` 
    },
    circle2: { 
        position: 'absolute', bottom: '-10%', right: '-5%', width: '400px', height: '400px', 
        borderRadius: '50%', background: `radial-gradient(circle, ${THEME.secondary}11 0%, transparent 70%)` 
    },
    card: { 
        width: '400px', 
        padding: '40px', 
        backgroundColor: 'rgba(255, 255, 255, 0.05)', 
        backdropFilter: 'blur(10px)',
        borderRadius: '24px', 
        border: '1px solid rgba(255, 255, 255, 0.1)',
        boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5)',
        textAlign: 'center',
        zIndex: 1
    },
    logoBadge: {
        width: '60px',
        height: '60px',
        backgroundColor: THEME.secondary,
        color: 'white',
        borderRadius: '16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '24px',
        fontWeight: 'bold',
        margin: '0 auto 20px',
        boxShadow: `0 10px 20px ${THEME.secondary}44`
    },
    title: { color: 'white', fontSize: '28px', margin: '0 0 10px 0', fontWeight: '800', letterSpacing: '1px' },
    subtitle: { color: '#94a3b8', fontSize: '14px', marginBottom: '30px' },
    form: { textAlign: 'left' },
    inputGroup: { marginBottom: '20px' },
    label: { display: 'block', color: '#cbd5e1', fontSize: '13px', fontWeight: '500', marginBottom: '8px', marginLeft: '4px' },
    input: { 
        width: '100%', 
        padding: '14px 16px', 
        backgroundColor: 'rgba(15, 23, 42, 0.5)', 
        borderRadius: '12px', 
        border: '1px solid rgba(255, 255, 255, 0.1)', 
        color: 'white',
        fontSize: '15px',
        outline: 'none',
        boxSizing: 'border-box',
        transition: '0.3s'
    },
    errorBox: { 
        padding: '12px', 
        backgroundColor: '#ef444422', 
        color: '#f87171', 
        borderRadius: '12px', 
        fontSize: '13px', 
        marginBottom: '20px', 
        border: '1px solid #ef444444' 
    },
    btn: { 
        width: '100%', 
        padding: '14px', 
        backgroundColor: THEME.secondary, 
        color: 'white', 
        border: 'none', 
        borderRadius: '12px', 
        cursor: 'pointer', 
        fontWeight: '700', 
        fontSize: '16px',
        marginTop: '10px',
        boxShadow: `0 10px 15px -3px ${THEME.secondary}44`,
        transition: '0.3s'
    },
    btnDisabled: {
        width: '100%', padding: '14px', backgroundColor: '#475569', color: '#94a3b8', border: 'none', borderRadius: '12px', cursor: 'not-allowed', marginTop: '10px'
    },
    footer: { marginTop: '30px', color: '#64748b', fontSize: '12px' }
};

export default Login;